import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['sidebar', 'close']

  connect() {
    if (window.chartInterval) clearInterval(window.chartInterval)
    this.toggleSidebar = this.toggleSidebar.bind(this)
    this.closeArea = document.querySelector('#close-sidebar-area')
    if (this.closeArea) {
      this.closeArea.addEventListener('click', this.toggleSidebar)
    }
  }

  disconnect() {
    if (this.closeArea) {
      this.closeArea.removeEventListener('click', this.toggleSidebar)
    }
  }

  sidebar() { this.toggleSidebar() }
  close() { this.toggleSidebar() }

  toggleSidebar() {
    this.sidebarTarget.classList.toggle('extended')
    this.closeTarget.classList.toggle('extended')
  }
}
